import { Clickable } from '@carvana/vdp-components';
import { useContext } from 'react';
import MenuOption from '~/constants/MenuOption';
import ModalContext from '~/contexts/ModalContext';
import SearchContext from '~/contexts/SearchContext';

const options = [MenuOption.Price, MenuOption.Make, MenuOption.Body];

export default function MenuOptions() {
  const { setFilterModalOpen } = useContext(ModalContext);
  const { setExpandOnOpen } = useContext(SearchContext);

  const handleClick = (option: MenuOption) => {
    setExpandOnOpen(option);
    setFilterModalOpen(true);
  };

  return (
    <div className="block border-0 border-b border-grey-2 border-solid pb-16 px-16 m:hidden">
      <div className="flex gap-8 items-center">
        {options.map(option => (
          <Clickable
            data-analytics-id={`Menu Option - ${option}`}
            className="border border-grey-2 border-solid min-[387px]:t-body-s px-12 py-8 rounded-[20px] t-body-xs text-blue-6" // below device width 387px the text stacks added custom breakpoint to change text size to fit in one line
            onClick={() => handleClick(option)}
            key={option}
          >
            {option}
          </Clickable>
        ))}
      </div>
    </div>
  );
}
